import {
  DATA_POINT_NATURE_LABEL,
  type DataPointNature,
} from "@/lib/building-domain";

export interface NatureChipRow {
  nature: DataPointNature;
  kind: string | null;
  connection_source: string | null;
  substituted?: boolean;
}

export interface NatureChip {
  label: string;
  color_nature: DataPointNature;
}

export function zoneRowIsSubstituted(
  source_id: string,
  name: string,
  signals_by_zone: Record<
    string,
    { relation: string; zone_data_point_id: string | null }[]
  >,
): boolean {
  return (signals_by_zone[source_id] ?? []).some(
    (signal) =>
      signal.relation === "substitute" && signal.zone_data_point_id === name,
  );
}

// Signaalit chip. Syöte is the existing connection_source chrome (AHU ← chiller),
// not a stored nature. A 1:1 substitute copy is stored calculated so a later
// native ingest still wins, but the quantity is a physical sensor. An equal-mix
// inference is also stored calculated on a sensor-kind channel — that one is
// Laskettu, not Anturitieto.
export function signalNatureChip(row: NatureChipRow): NatureChip {
  if (row.connection_source) {
    return { label: "Syöte", color_nature: row.nature };
  }
  if (row.kind === "sensor" && row.nature === "calculated" && row.substituted) {
    return {
      label: DATA_POINT_NATURE_LABEL.sensor,
      color_nature: "sensor",
    };
  }
  return {
    label: DATA_POINT_NATURE_LABEL[row.nature] ?? row.nature,
    color_nature: row.nature,
  };
}
